var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',[_c('router-view')],1):_c('div',{staticClass:"flex justify-center items-center h-screen"},[_vm._v(" carregando... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }